import { css as w, LitElement as b, nothing as c, html as g } from "lit";
import { query as p, property as l, state as y, customElement as E } from "lit/decorators.js";
import { classMap as m } from "lit/directives/class-map.js";
import { o as O, f as k, s as x, a as $, c as T, b as C } from "./floating-ui.dom-Cma46hoU.js";
import { b as L } from "./styles-scZ6dVz-.js";
import { b as u, a as v } from "./events-CkEPl0SM.js";
import { g as A } from "./a11y-DxQW21Jt.js";
var P = Object.defineProperty, S = Object.getOwnPropertyDescriptor, o = (t, r, d, s) => {
  for (var i = s > 1 ? void 0 : s ? S(r, d) : r, n = t.length - 1, a; n >= 0; n--)
    (a = t[n]) && (i = (s ? a(r, d, i) : a(i)) || i);
  return s && i && P(r, d, i), i;
};
let e = class extends b {
  constructor() {
    super(...arguments), this.popoverId = A("ark-popover"), this.open = !1, this.placement = "bottom", this.offset = 8, this.showArrow = !0, this.hoverTrigger = !1, this.closeOnOutside = !0, this.arrowSide = "top", this.handleOutsideClick = (t) => {
      this.open && this.closeOnOutside && !this.contains(t.target) && this.hide();
    }, this.handleKeydown = (t) => {
      t.key === "Escape" && this.open && this.hide();
    };
  }
  /** Open the popover */
  show() {
    this.open = !0;
  }
  /** Close the popover */
  hide() {
    this.open = !1;
  }
  /** Toggle the popover */
  toggle() {
    this.open = !this.open;
  }
  async updatePosition() {
    if (!this.triggerElement || !this.contentElement) return;
    const t = this.triggerElement.querySelector("slot")?.assignedElements()[0] || this.triggerElement, r = [
      O(this.offset),
      k(),
      x({ padding: 8 })
    ];
    this.showArrow && this.arrowElement && r.push($({ element: this.arrowElement }));
    const { x: d, y: s, placement: i, middlewareData: n } = await T(
      t,
      this.contentElement,
      {
        placement: this.placement,
        middleware: r
      }
    );
    if (Object.assign(this.contentElement.style, {
      left: `${d}px`,
      top: `${s}px`
    }), this.showArrow && n.arrow) {
      const { x: a, y: h } = n.arrow, f = i.split("-")[0];
      this.arrowSide = {
        top: "bottom",
        bottom: "top",
        left: "right",
        right: "left"
      }[f], Object.assign(this.arrowElement.style, {
        left: a != null ? `${a}px` : "",
        top: h != null ? `${h}px` : "",
        [this.arrowSide]: "-6px"
      });
    }
  }
  handleTriggerClick() {
    this.hoverTrigger || this.toggle();
  }
  handleTriggerMouseEnter() {
    this.hoverTrigger && this.show();
  }
  handleTriggerMouseLeave() {
    this.hoverTrigger && this.hide();
  }
  updated(t) {
    if (t.has("open"))
      if (this.open) {
        this.updatePosition();
        const r = this.triggerElement.querySelector("slot")?.assignedElements()[0] || this.triggerElement;
        this.cleanupAutoUpdate = C(
          r,
          this.contentElement,
          () => this.updatePosition()
        ), document.addEventListener("click", this.handleOutsideClick), document.addEventListener("keydown", this.handleKeydown), u(this, v.OPEN);
      } else
        this.cleanupAutoUpdate?.(), document.removeEventListener("click", this.handleOutsideClick), document.removeEventListener("keydown", this.handleKeydown), u(this, v.CLOSE);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.cleanupAutoUpdate?.(), document.removeEventListener("click", this.handleOutsideClick), document.removeEventListener("keydown", this.handleKeydown);
  }
  render() {
    const t = {
      content: !0,
      open: this.open
    }, r = {
      arrow: !0,
      [this.arrowSide]: !0
    };
    return g`
      <span
        part="trigger"
        class="trigger"
        @click=${this.handleTriggerClick}
        @mouseenter=${this.handleTriggerMouseEnter}
        @mouseleave=${this.handleTriggerMouseLeave}
        aria-describedby=${this.open ? this.popoverId : c}
      >
        <slot name="trigger"></slot>
      </span>

      <div
        part="content"
        class=${m(t)}
        id=${this.popoverId}
        role="tooltip"
        aria-hidden=${!this.open}
        @mouseenter=${this.handleTriggerMouseEnter}
        @mouseleave=${this.handleTriggerMouseLeave}
      >
        <slot></slot>
        ${this.showArrow ? g`<div part="arrow" class=${m(r)}></div>` : c}
      </div>
    `;
  }
};
e.styles = [
  L,
  w`
      :host {
        display: inline-block;
      }

      .trigger {
        display: inline-flex;
      }

      .content {
        position: fixed;
        z-index: var(--r5-z-popover);
        background-color: var(--r5-bg);
        border: 1px solid var(--r5-border);
        border-radius: var(--r5-radius-lg);
        box-shadow: var(--r5-shadow-lg);
        padding: var(--r5-space-4);
        opacity: 0;
        visibility: hidden;
        transform: scale(0.95);
        transition: opacity var(--r5-duration-fast) var(--r5-ease-default),
                    visibility var(--r5-duration-fast) var(--r5-ease-default),
                    transform var(--r5-duration-fast) var(--r5-ease-default);
        max-width: min(calc(100vw - 1rem), 20rem);
      }

      .content.open {
        opacity: 1;
        visibility: visible;
        transform: scale(1);
      }

      .arrow {
        position: absolute;
        width: 0.75rem;
        height: 0.75rem;
        background-color: var(--r5-bg);
        border: 1px solid var(--r5-border);
        transform: rotate(45deg);
      }

      .arrow.top {
        border-top: none;
        border-left: none;
      }

      .arrow.bottom {
        border-bottom: none;
        border-right: none;
      }

      .arrow.left {
        border-left: none;
        border-bottom: none;
      }

      .arrow.right {
        border-right: none;
        border-top: none;
      }

      @media (prefers-reduced-motion: reduce) {
        .content {
          transition: none;
        }
      }
    `
];
o([
  p(".trigger")
], e.prototype, "triggerElement", 2);
o([
  p(".content")
], e.prototype, "contentElement", 2);
o([
  p(".arrow")
], e.prototype, "arrowElement", 2);
o([
  l({ type: Boolean, reflect: !0 })
], e.prototype, "open", 2);
o([
  l({ type: String })
], e.prototype, "placement", 2);
o([
  l({ type: Number })
], e.prototype, "offset", 2);
o([
  l({ type: Boolean, attribute: "show-arrow" })
], e.prototype, "showArrow", 2);
o([
  l({ type: Boolean, attribute: "hover-trigger" })
], e.prototype, "hoverTrigger", 2);
o([
  l({ type: Boolean, attribute: "close-on-outside" })
], e.prototype, "closeOnOutside", 2);
o([
  y()
], e.prototype, "arrowSide", 2);
e = o([
  E("ark-popover")
], e);
export {
  e as A
};
//# sourceMappingURL=ark-popover-BCQav8XS.js.map
